import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Subject} from "rxjs";
import {ActivityI} from "../../../../infrastructure/interfaces/task.interface";
import {InfoTokenService, TranslateService} from "@mangosoft/mango-layout";

@Component({
  selector: 'app-services-executions',
  templateUrl: './services-executions.component.html',
  styleUrls: ['./services-executions.component.scss']
})
export class ServicesExecutionsComponent implements OnInit, OnDestroy {
  destroy$ = new Subject<void>();

  @Input() activityData: ActivityI | null = null;


  language: string = "es";
  token!: string;

  config!: any;

  constructor(
    private translateService: TranslateService,
    private authService: InfoTokenService
  ) {
  }

  ngOnInit() {
    this.token = this.authService.getToken();
    console.log("services executions => ", this.activityData);
    if (this.activityData?.api){
      this.config = {
        api: this.activityData.api,
        token: this.token,
        collections: this.activityData?.metadata?.collections || [],
        jobId: this.activityData?.metadata?.job_id || "",
        job_data: this.activityData?.metadata?.job_data || {},
        job_files: this.activityData?.metadata?.job_files || []
      }
      console.log("services executions config => ", this.config);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
